/**
* How It Works Slides JS
* -----------------------------------------------------------------------------
*
* All the JS for the How It Works Slides component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';

( function( app ) {
  const COMPONENT = {

    className: 'how-it-works-slides',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );

      let loggedIn = false;

      if ( $( '.logged-in' ).length > 0 ) {
        loggedIn = true;
      }

      let top = '56px';
      if ( loggedIn === true ) {
        top = '88px';
      }

      $( window ).on( 'resize', function() {
        let loggedIn = false;

        if ( $( '.logged-in' ).length > 0 ) {
          loggedIn = true;
        }

        let top = '69px';
        if ( loggedIn === true ) {
          top = '101px';
        }
      } );

      const totalSlides = $( '.how-it-works__slide' ).length;

      gsap.defaults( {ease: 'none', duration: 500} );

      const tl = gsap.timeline();
      tl.to( '.slide-0 .intro-wrapper .intro-font', {scale: 0.21, translateX: '-38%', translateY: '-260%', duration: 4500} );

      for ( let x = 1; x <= totalSlides; x++ ) {
        if ( x < totalSlides-1 ) {
          tl.from( '.slide-' + x, {opacity: 0, pointerEvents: 'none', duration: 2000} )
              .from( '.slide-' + x + ' .content-wrapper .inner-content', {opacity: 0, y: 100, duration: 1500, pointerEvents: 'none'} )
              .to( '.slide-' + x + ' .content-wrapper .inner-content', {y: 0, opacity: 1, duration: 2000} )
              .to( '.slide-' + x + ' .content-wrapper .inner-content', {opacity: 0, y: -100, duration: 7000, ease: CustomEase.create( 'custom', 'M0,0 C0.122,-0.084 0.347,-0.15 0.498,-0.04 0.802,0.182 0.693,1 1,1 ' )} );
        } else {
          tl.from( '.slide-' + x, {opacity: 0, pointerEvents: 'none'} )
              .from( '.slide-' + x + ' .content-wrapper .inner-content', {opacity: 0, y: 100, duration: 2000, pointerEvents: 'none'} )
              .to( '.slide-' + x + ' .content-wrapper .inner-content', {y: 0, opacity: 1, duration: 2000} );
        }
      }
      // console.log( document.querySelector( '.how-it-works-slides' ).offsetHeight );
      let totalHeight = 0;
      $( '.how-it-works__slide .slide' ).each( function() {
        totalHeight = $( this ).outerHeight() + totalHeight;
      } );
      // console.log( $( window ).height() );
      $( '.how-it-works-slides' ).outerHeight( totalHeight + $( window ).height() );
      ScrollTrigger.create( {
        animation: tl,
        trigger: '.how-it-works__pin',
        // start: 'top top+=88px',
        start: 'top top+='+top,
        // end: 'end+=194%',
        end: 'end+='+totalHeight,
        scrub: 1,
        pin: true,
        pinSpacing: false,
        anticipatePin: true,
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'how-it-works-slides', COMPONENT );
} )( app );
